export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13329.8459a1c0.jpg";